/**
 * 验证英文、数字、下划线
 * 
 * @param {String} value 需要验证的字符串
 * @returns {Boolean} true || false
 */
export function validateEnglishNumberUnderline(value) {
  if (value) {
    return /^\w+$/.test(value)
  } else {
    return false
  }
}

/**
 * 验证英文、数字、下划线、空格
 * 
 * @param {String} value 需要验证的字符串
 * @returns {Boolean} true || false
 */
export function validateEnglishNumberUnderlineSpace(value) {
  if (value) {
    return /^[\w\s]*$/.test(value)
  } else {
    return false
  }
}

/**
 * 验证英文、数字、下划线、空格、中文
 * 
 * @param {String} value 需要验证的字符串
 * @returns {Boolean} true || false
 */
export function validateEnglishNumberUnderlineSpaceChinese(value) {
  if (value) {
    return /^[\w\s\u4e00-\u9fa5]*$/.test(value)
  } else {
    return false
  }
}

/**
 * 验证是否是有效的URL
 *
 * @param {string} url
 * @returns {Boolean}
 */
export function validateURL(url) {
  let reg = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/
  return reg.test(url)
}

/**
 * 验证是否是有效的邮箱地址
 * 
 * @param {string} email
 * @returns {Boolean}
 */
export function validateEmail(email) {
  const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

/**
 * 匹配到中文就删除掉输入的中文内容
 * @param {string} value
*/
export function matchChinese(value) {
  return /[\u4e00-\u9fa5]/g.test(value)
}

/**
 * 正则验证非中文
 * @param {string} value
 * @returns {Boolean}
*/
export function nonChinese(value) {
  return !/[\u4e00-\u9fa5]/.test(value)
}

/**
 * 正则验证手机号
 * @param {string} value
 * @returns {Boolean}
*/
export function telephoneNumber(value) {
  return /^\+?\d+(?:[\s-]\d+)*$/.test(value)
}

/**
 * 正则验证（国外手机号）
 * @param {string} value
 * @returns {Boolean}
*/
export function generalPhoneNumber(value) {
  return /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/.test(value)
}

/**
 * 正则验证欧盟及英美加拿大邮编验证
 * @param {string} value
 * @returns {Boolean}
*/
export function isValidPostalCode(value, countryCode) {
  let postalCodeRegex
  switch (countryCode) {
    case 'US':
      postalCodeRegex = /^\d{5}([ \-]\d{4})?$/
      break
    case 'CA':
      postalCodeRegex = /^[ABCEGHJKLMNPRSTVXY]{1}\d{1}[A-Z]{1} *\d{1}[A-Z]{1}\d{1}$/
      break
    case 'GB':
      postalCodeRegex = /^([A-PR-UWYZ]([0-9]{1,2}|([A-HK-Y][0-9]|[A-HK-Y][0-9]([0-9]|[ABEHMNPRV-Y]))|[0-9][A-HJKS-UW])\ [0-9][ABD-HJLNP-UW-Z]{2}|(GIR\ 0AA)|(SAN\ TA1)|(BFPO\ (C\/O\ )?[0-9]{1,4})|((ASCN|BBND|[BFS]IQQ|PCRN|STHL|TDCU|TKCA)\ 1ZZ))$/
      break
    case 'AT':
      postalCodeRegex = /^\d{4}$/
      break
    case 'BE':
      postalCodeRegex = /^\d{4}$/
      break
    case 'BG':
      postalCodeRegex = /^\d{4}$/
      break
    case 'CY':
      postalCodeRegex = /^\d{4}$/
      break
    case 'HR':
      postalCodeRegex = /^\d{5}$/
      break
    case 'CZ':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'DK':
      postalCodeRegex = /^\d{4}?$/
      break
    case 'EE':
      postalCodeRegex = /^\d{5}$/
      break
    case 'FI':
      postalCodeRegex = /^\d{5}$/
      break
    case 'FR':
      postalCodeRegex = /^\d{5}$/
      break
    case 'DE':
      postalCodeRegex = /^\d{4,5}$/
      break
    case 'GR':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'HU':
      postalCodeRegex = /^\d{4}$/
      break
    case 'IT':
      postalCodeRegex = /^\d{2,5}$/
      break
    case 'LV':
      postalCodeRegex = /^(?:LV-)*(\d{4})$/
      break
    case 'LT':
      postalCodeRegex = /^\d{5}$/
      break
    case 'LU':
      postalCodeRegex = /^(?:L-)*\d{3,4}$/
      break
    case 'MT':
      postalCodeRegex = /^[A-Z]{3}[ ]?\d{2,4}$/
      break
    case 'NL':
      postalCodeRegex = /^\d{4}[ ]?[A-Z]{2}$/
      break
    case 'PL':
      postalCodeRegex = /^\d{2}-\d{3}$/
      break
    case 'PT':
      postalCodeRegex = /^\d{4}([\-]\d{3})?$/
      break
    case 'RO':
      postalCodeRegex = /^\d{6}$/
      break
    case 'SK':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    case 'SI':
      postalCodeRegex = /^\d{4}$/
      break
    case 'ES':
      postalCodeRegex = /^\d{4,5}$/
      break
    case 'SE':
      postalCodeRegex = /^\d{3}[ ]?\d{2}$/
      break
    default:
      postalCodeRegex = /^(?:[A-Za-z0-9]+([- ]?[A-Za-z0-9]+)*)?$/
  }
  return postalCodeRegex.test(value)
}
